import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import * as uuid from 'uuid';
@Component({
  selector: 'app-filter-object-option-select',
  templateUrl: './filter-object-option-select.component.html',
  styleUrls: ['./filter-object-option-select.component.scss']
})
export class FilterObjectOptionSelectComponent {

  ContainerId = uuid.v4()

  @Input() IconUrl: string = "/assets/icons/credit-card.svg"
  @Input() PlaceholderFilter: string = "Matricula"
  @Input() NoOptionsText: string = "Ninguna matricula introducida"
  @Input() SelectedText: string = "Matriculas"
  @Input() SelectedOptions: string[] | any[] = []
  @Input() Options: any[] = []
  @Input() Multiselect: boolean = false;
  @Input() BindId: string = "";
  @Input() BindName: string = "";
  @Input() PopupWidth: string | undefined;
  @Input() zIndex: number = 1;
  @Input() Height: string = 'auto';

  @Output() filterValueEmitter = new EventEmitter<any[]>()

  FilterOpen: boolean = false;

  // Could be a number or 
  SelectedOptionsIds: (string | number)[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['SelectedOptions'] || changes['BindId']) {
      this.updateSelectedIds();
    }
  }

  updateSelectedIds() {
    this.SelectedOptionsIds = this.SelectedOptions.map((x: any) => { return x[this.BindId] })
  }

  openFilter() {
    this.FilterOpen = !this.FilterOpen;
  }

  deleteFilter(event: Event) {
    event.stopPropagation();
    this.SelectedOptions = [];
    this.FilterOpen = false;
    this.emitFilterValue();
  }


  emitFilterValue() {
    this.filterValueEmitter.emit(this.SelectedOptions);
  }


  updateSelectedOption(option: any, event: Event) {
    event.stopPropagation();

    if (this.Multiselect) {
      if (this.SelectedOptionsIds.includes(option[this.BindId])) {
        this.SelectedOptions = this.SelectedOptions.filter((x: any) => x[this.BindId] !== option[this.BindId]);
      } else {
        this.SelectedOptions.push(option);
      }
    } else {
      if (this.SelectedOptionsIds.includes(option[this.BindId])) {
        this.SelectedOptions = [];
      } else {
        this.SelectedOptions = [option];
      }
    }

    this.updateSelectedIds();
    this.emitFilterValue();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;
    const absoluteElement = document.getElementById(this.ContainerId);
    if (
      this.FilterOpen &&
      absoluteElement &&
      !absoluteElement.contains(targetElement)
    ) {
      this.FilterOpen = false;
    }
  }


}

